// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2BX-B","list":"styles_list__2obcU"};